import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-407bb4ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "search-result-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "heading1" }, "LEI-Suche"),
  /*#__PURE__*/_createElementVNode("p", { class: "heading2" }, "Ergebnisse")
], -1))
const _hoisted_4 = { class: "right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Alle Status", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "ISSUED", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "LAPSED", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "RETIRED", -1))
const _hoisted_9 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "search-result" }
const _hoisted_11 = { class: "table" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "leiStatus" }
const _hoisted_14 = { class: "tooltip" }
const _hoisted_15 = { class: "tooltiptext" }
const _hoisted_16 = {
  key: 0,
  class: "material-icons material-symbols-outlined",
  style: {"color":"green"}
}
const _hoisted_17 = {
  key: 1,
  class: "material-icons material-symbols-outlined",
  style: {"color":"orange"}
}
const _hoisted_18 = {
  key: 2,
  class: "material-icons material-symbols-outlined",
  style: {"color":"red"}
}
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { class: "lei" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_pagination = _resolveComponent("base-pagination")!

  return (_ctx.searchActive || _ctx.items.length > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.option) = $event))
            }, _hoisted_9, 512), [
              [_vModelSelect, _ctx.option]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("table", _hoisted_11, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                  return (_openBlock(), _createElementBlock("th", { key: column }, _toDisplayString(column), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeItems, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.lei,
                  onClick: ($event: any) => (_ctx.showDetails(item.lei))
                }, [
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(item.status), 1),
                      (item.status === 'ISSUED')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, " check_circle️ "))
                        : (item.status === 'LAPSED')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, " hourglass_bottom️️ "))
                          : (item.status === 'RETIRED')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, " warning "))
                            : (_openBlock(), _createElementBlock("div", _hoisted_19))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(item.lei), 1),
                  _createElementVNode("td", null, _toDisplayString(item.name), 1),
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(item.js.street), 1),
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(item.js.city), 1),
                    _hoisted_22,
                    _createTextVNode(" " + _toDisplayString(item.js.country), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(item.vs.street), 1),
                    _hoisted_23,
                    _createTextVNode(" " + _toDisplayString(item.vs.city), 1),
                    _hoisted_24,
                    _createTextVNode(" " + _toDisplayString(item.vs.country), 1)
                  ])
                ], 8, _hoisted_12))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_base_pagination, {
            totalPages: +_ctx.itemLength,
            perPage: 10,
            currentPage: _ctx.currentPage,
            onPagechanged: _ctx.onPageChange
          }, null, 8, ["totalPages", "currentPage", "onPagechanged"])
        ])
      ]))
    : _createCommentVNode("", true)
}